export default __webpack_public_path__ + "1f0fd1c67a6080f347ff1f89aa3346ce.png";